import { render, staticRenderFns } from "./create-promotion-btn.vue?vue&type=template&id=6e0c42a1"
import script from "./create-promotion-btn.vue?vue&type=script&lang=js"
export * from "./create-promotion-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports